/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetRoles200ResponseInner
 */
export interface GetRoles200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRoles200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoles200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoles200ResponseInner
     */
    'category': GetRoles200ResponseInnerCategoryEnum;
}

export const GetRoles200ResponseInnerCategoryEnum = {
    system: 'SYSTEM',
    app: 'APP',
    card: 'CARD'
} as const;

export type GetRoles200ResponseInnerCategoryEnum = typeof GetRoles200ResponseInnerCategoryEnum[keyof typeof GetRoles200ResponseInnerCategoryEnum];


